export const EXCHANGE = [
  { label: "CSE", value: 1 },
  { label: "QSE", value: 2 },
  { label: "SSE", value: 3 },
  { label: "NASDAQ", value: 4 },
  // { label: "All", value: 5 },
];

export const SECTORS = [
  { label: "Energy", value: 1 },
  { label: "Materials", value: 2 },
  { label: "Industrials", value: 3 },
  { label: "Consumer Discretionary", value: 4 },
  { label: "Consumer Staples", value: 5 },
  { label: "Health Care", value: 6 },
  { label: "Financials", value: 7 },
  { label: "Information Technology", value: 8 },
  { label: "Communication Services", value: 9 },
  { label: "Utilities", value: 10 },
  { label: "Real Estate", value: 11 },
  // { label: "All", value: 12 },
];

export const TIME_FRAMES = [
  //{ label: "Annual", value: "annual" },
  { label: "LTM", value: "ltm" },
  { label: "Latest Quarter", value: "last_quater" },
];

export const MULTIPLES = [
  { label: "All", value: 0 },
  { label: "Less than 5", value: 1 },
  { label: "Less than 10", value: 2 },
  { label: "Less than 15", value: 3 },
  { label: "More than 5", value: 4 },
  { label: "More than 10", value: 5 },
  { label: "More than 15", value: 6 },
];

export const MULTIPLES_PE_RATIO = [
  { label: "All", value: 0 },
  { label: "Less than 5", value: -5 },
  { label: "Less than 10", value: -10 },
  { label: "Less than 15", value: -15 },
  { label: "More than 5", value: 5 },
  { label: "More than 10", value: 10 },
  { label: "More than 15", value: 15 },
];

export const MULTIPLES_PB_RATIO = [
  { label: "All", value: 0 },
  { label: "Less than 1", value: -1 },
  { label: "Less than 2", value: -2 },
  { label: "Less than 3", value: -3 },
  { label: "More than 1", value: 1 },
  { label: "More than 2", value: 2 },
  { label: "More than 3", value: 3 },
];

export const MULTIPLES_DE_RATIO = [
  { label: "All", value: 0 },
  { label: "Less than 0.5", value: -0.5 },
  { label: "Less than 1", value: -1 },
  { label: "Less than 1.5", value: -1.5 },
  { label: "More than 0.5", value: 0.5 },
  { label: "More than 1", value: 1 },
  { label: "More than 1.5", value: 1.5 },
];

export const PERCENTAGES = [
  { label: "All", value: 0 },
  { label: "Less than 5%", value: -5 },
  { label: "Less than 10%", value: -10 },
  { label: "Less than 15%", value: -15 },
  { label: "More than 5%", value: 5 },
  { label: "More than 10%", value: 10 },
  { label: "More than 15%", value: 15 },
];

export const PERCENTAGES_DIVIDEND_YIELD = [
  { label: "All", value: 0 },
  { label: "Less than 2%", value: -2 },
  { label: "Less than 4%", value: -4 },
  { label: "Less than 6%", value: -6 },
  { label: "More than 2%", value: 2 },
  { label: "More than 4%", value: 4 },
  { label: "More than 6%", value: 6 },
];

export const PERCENTAGES_DIVIDEND_PAYOUT = [
  { label: "All", value: 0 },
  { label: "Less than 30%", value: -30 },
  { label: "Less than 50%", value: -50 },
  { label: "Less than 70%", value: -70 },
  { label: "More than 30%", value: 30 },
  { label: "More than 50%", value: 50 },
  { label: "More than 70%", value: 70 },
];


export const PERCENTAGES_GROSS_MARGIN = [
  { label: "All", value: 0 },
  { label: "Less than 20%", value: -20 },
  { label: "Less than 40%", value: -40 },
  { label: "Less than 60%", value: -60 },
  { label: "More than 20%", value: 20 },
  { label: "More than 40%", value: 40 },
  { label: "More than 60%", value: 60 },
];

export const CURRENCY = [
  { label: "USD", value: 1 },
  { label: "LKR", value: 2 },
  { label: "QAR", value: 3 },
  { label: "SAR", value: 4 },
  { label: "INR", value: 5 },
];
